exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-flexLayout{display:flex}.ba-common-flexLayout.is-fullHeight{height:100%}.ba-common-flexLayout__sw{position:absolute;top:0;left:0;right:0;bottom:0}.ba-common-flexLayout-item{min-width:0;min-height:0;max-width:100%}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ba-common-flexLayout-item{max-width:100%}}", ""]);

// exports
